import React from 'react';
import { CaretLeft } from 'phosphor-react';

export function ReviewHeader({ onBack }) {
  return (
    <div className="w-full px-4 pt-4 pb-0 mb-1 max-w-[1600px] mx-auto xl:px-10 max-xl:px-6">
      <div className="review-header flex flex-row items-center justify-between gap-4 py-4 px-6 rounded-xl shadow-[0_2px_8px_rgba(18,118,109,0.15)] bg-gradient-to-br from-[#12766d] via-[#236463] to-[#1d4746] dark:from-[#0d4f49] dark:via-[#153938] dark:to-[#0f2928] dark:shadow-[0_2px_8px_rgba(0,0,0,0.3)] max-xl:justify-center max-xl:relative">
        <div className="flex items-center gap-3">
          <button
            type="button"
            className="flex items-center gap-1.5 bg-transparent border-none text-white/90 text-[13px] font-medium cursor-pointer py-1.5 px-2.5 transition-all duration-300 w-fit hover:text-white max-xl:absolute max-xl:left-4 max-xl:py-1.5 max-xl:px-1.5 max-xl:gap-0"
            onClick={onBack}
            aria-label="Back to Result"
          >
            <CaretLeft size={18} weight="bold" className="shrink-0" aria-hidden />
            <span className="max-xl:hidden">Back to Result</span>
          </button>
        </div>

        <div className="flex flex-col gap-0.5 flex-1 items-center max-xl:flex-1 max-xl:text-center max-xl:m-0 max-xl:mx-auto">
          <h1 className="text-white text-2xl font-bold m-0 text-center tracking-wide">Review</h1>
        </div>
      </div>
    </div>
  );
}
